const Footer = () => {
  
  return (
    <footer>
      <div className="wrapper">
        <p>Created at <a href="https://junocollege.com/">Juno College</a></p>
      </div>
    </footer>
  )
}

export default Footer;